import { Settings } from 'superlikers-dynamic-forms'

import { EyeIcon, EyeOffIcon, AutocompleteClearIcon, AutocompleteLoadingIcon } from '@shared/components'

export const settings: Settings = {
  wrapperClasses: 'flex flex-col gap-1.5 text-left relative',
  labelClasses: 'preset-body-4 md:preset-body-3 text-white',
  errorClasses: 'preset-body-4 md:preset-body-3 text-danger-900',
  helpTextClasses: 'preset-body-4 md:preset-body-3 text-white',
  inputClasses:
    'rounded-full border border-primary-300 text-white preset-body-4 md:preset-body-3 py-1 px-4 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-transparent transition-shadow disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none disabled:bg-gray-500/30',
  passwordEyeOpenIcon: EyeIcon,
  passwordEyeCloseIcon: EyeOffIcon,
  passwordIconClasses: 'w-5 h-5 text-primary-300 hover:text-white cursor-pointer transition-colors absolute right-3 top-6 md:top-7',
  // Checkbox controls
  checkboxWrapperClasses: 'flex items-center gap-2',
  checkboxInputClasses: 'w-4 h-4 rounded transition-all duration-150 cursor-pointer',
  checkboxLabelTextClasses: 'preset-body-4 md:preset-body-3 text-white',
  // autocomplete controls
  autocompleteInputClasses:
    'rounded-full border border-primary-300 w-full text-white preset-body-4 md:preset-body-3 py-1 px-4 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-transparent transition-shadow disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none disabled:bg-gray-500/30',
  autocompleteDropdownClasses: 'w-full min-w-46 preset-body-4 md:preset-body-3 rounded-xl p-2 border border-primary-300 text-white bg-primary-700 shadow-lg overflow-hidden',
  autocompleteDropdownItemClasses: 'px-4 py-2 cursor-pointer',
  autocompleteDropdownItemHoverClasses: 'bg-primary-500',
  autocompleteDropdownItemSelectedClasses: 'bg-primary-500 font-semibold',
  autocompleteLoadingText: 'Buscando...',
  autocompleteLoadingTextClasses: 'preset-body-4 md:preset-body-3 text-primary-300',
  autocompleteLoadingIcon: AutocompleteLoadingIcon,
  autocompleteLoadingIconClasses: 'w-4 h-4 text-primary-300',
  autocompleteLoadingWrapperClasses: 'absolute right-3 top-1/2 -translate-y-1/2',
  autocompleteClearIcon: AutocompleteClearIcon,
  autocompleteClearIconClasses: 'w-4 h-4 text-primary-300 hover:text-white cursor-pointer transition-colors',
  autocompleteClearWrapperClasses: 'absolute right-3 top-1/2 -translate-y-1/2',
  // Array controls
  arrayItemFieldsetClasses: 'flex flex-col gap-4',
  arrayItemContainerClasses: 'flex flex-col gap-2 border border-white/20 rounded-xl p-3',
  arrayControlAddButtonLabel: '+ Agregar vendedor',
  arrayControlAddButtonClasses: 'preset-title-5 md:preset-title-4 shadow-button-inset cursor-pointer rounded-3xl px-4 py-1 text-primary-900 bg-accent-900 disabled:opacity-50 disabled:cursor-not-allowed',
  arrayControlRemoveButtonLabel: 'Eliminar',
  arrayControlRemoveButtonClasses: 'preset-body-4 cursor-pointer rounded-3xl px-3 py-0.5 text-white border border-white/40 hover:border-white transition-colors self-end'
}
